import { engine } from "..";
import { trackLiveObjects } from "../helpers/trackLiveObjects";
import { withDelete } from "../helpers/withDelete";
import { buildSuggestion } from "../technicalSelection/helpers/buildSuggestion";
import { buildSuggestionPipe } from "../technicalSelection/helpers/buildSuggestionPipe";
import {
  initSuggestionArgs,
  ValveSuggestionArgsOptions,
} from "../technicalSelection/suggestionsArgs/initSuggestionArgs";

export const projectRepository = trackLiveObjects("projectRepository", {
  calculateSelectionOutput(
    delimitedId: string,
    pipeSizeId: string,
    options: ValveSuggestionArgsOptions,
  ) {
    const { cleanup: cleanupSuggestionArgs, suggestionArgs: args } =
      initSuggestionArgs(options);
    if (!args || options.filters?.flow === 0) {
      cleanupSuggestionArgs();
      return {
        pipeResults: null,
        status: "success" as const,
        suggestion: null,
      };
    }
    const suggestionOutputs = new engine.SuggestionOutputsEdit(
      options.categoryId,
      delimitedId,
      pipeSizeId,
      args,
    );
    suggestionOutputs.retrieveSuggestionOutputs();
    cleanupSuggestionArgs();
    return withDelete(suggestionOutputs, {
      pipeResults: buildSuggestionPipe(suggestionOutputs.getPipeResult()),
      suggestion: buildSuggestion(suggestionOutputs.getSuggestion()),
    });
  },
});
